import React from "react";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  const navLinks = [
    { href: "/about", label: "About" },
    { href: "/publications", label: "Publications" },
    { href: "/patents-awards", label: "Patents & Awards" },
    { href: "/teaching", label: "Teaching" },
    { href: "/projects", label: "Projects" },
    { href: "/blog", label: "Blog" },
  ];

  const socialLinks = [
    { href: "https://github.com/ekremcet", label: "GitHub" },
    { href: "mailto:ekrem.cetinkaya@yildiz.edu.tr", label: "Email" },
  ];

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 sm:p-8">
      <div className="max-w-2xl w-full">
        {/* Business Card Container */}
        <div className="border-2 border-black p-6 sm:p-12 bg-white">
          {/* Header */}
          <div className="text-center mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-2 font-mono">
              Ekrem Çetinkaya
            </h1>
            <p className="text-sm sm:text-lg text-gray-600 font-mono">
              Research, education, and entrepreneurship
            </p>
          </div>

          {/* Navigation Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="button-minimal text-center py-3 sm:py-2"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Separator */}
          <div className="border-t border-black my-6 sm:my-8"></div>

          {/* Social Links */}
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-3 sm:space-y-0 sm:space-x-6">
            {socialLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-mono underline hover:no-underline hover:bg-black hover:text-white px-2 py-1 transition-all duration-200"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Footer */}
          <div className="text-center mt-6 sm:mt-8">
            <p className="text-xs font-mono text-gray-500">
              Asst. Prof. at Yildiz Technical University
            </p>
          </div>
        </div>

        {/* Minimal footer outside the card */}
        <div className="text-center mt-6 sm:mt-8">
          <p className="text-xs text-gray-400 font-mono">
            © 2026 — Ekrem Çetinkaya
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
